'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { AddressInfo } from 'my-purchases/components/AddressInfo/AddressInfo'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import { cx } from 'utils/cx'

import styles from './Addresses.module.scss'

interface AddressesProps {
	readonly order: OrderDetails
	readonly className?: string
}

export function Addresses({ order, className }: AddressesProps) {
	const { t } = useLabels()

	const { delivery, billing } = order

	return delivery || billing ? (
		<div
			className={cx(styles.wrapper, className)}
			data-testid='myPurchases.online.details.addresses.container'
		>
			{delivery && (
				<div data-testid='myPurchases.online.details.deliveryAddress'>
					<h2>{t('my_purchases.subtitle.delivery_details')}</h2>
					<AddressInfo
						address={delivery}
						data-testid='myPurchases.online.details.deliveryAddress'
					/>
				</div>
			)}
			{billing && (
				<div data-testid='myPurchases.online.details.billingAddress'>
					<h2>{t('my_purchases.subtitle.invoicing_details')}</h2>
					<AddressInfo
						address={billing}
						data-testid='myPurchases.online.details.billingAddress'
					/>
				</div>
			)}
		</div>
	) : null
}
